import * as React from "react";

import DetailsTitle from '../../CustomeComponents/DetailsTitle';
import Section from "../Section";
import TablePikuahBniaList from "./TablePikuahBniaList";

const TikimPikuahBnia = (props) => {

  return (
    <div className="container my-3 my-lg-5">
      <DetailsTitle />

      <Section icon={'eye'} title={'תיקים'} className="mt-3">
        <TablePikuahBniaList pikuahData={props.pikuahBniaData}/>
      </Section>
    </div>
  );
}

export default TikimPikuahBnia;